import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import ScenarioItem from './ScenarioItem';

// Workplace image mapping for different scenario types
const SCENARIO_IMAGES = {
  // Workplace Social Scenarios (1-15)
  "Cross-Cultural Misunderstanding": "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Handling Public Criticism": "https://images.unsplash.com/photo-1560439513-74b037a25d84?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Team Member Not Pulling Their Weight": "https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Navigating Office Politics": "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Dealing with a Micromanaging Boss": "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Presentation Anxiety": "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Being Interrupted in Meetings": "https://images.unsplash.com/photo-1566554273541-37a9ca77b91f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Facilitating a Contentious Meeting": "https://images.unsplash.com/photo-1531482615713-2afd69097998?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Delivering Bad News to a Team": "https://images.unsplash.com/photo-1588196749597-9ff075ee6b5b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Workplace Social Scenarios (16-31)
  "Business Lunch Etiquette Dilemma": "https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80", 
  "Appropriate Business Gift Giving": "https://images.unsplash.com/photo-1576075796033-848c2a5f3696?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Navigating Dress Code Expectations": "https://images.unsplash.com/photo-1600878459108-617a253537d2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Digital Communication Etiquette": "https://images.unsplash.com/photo-1557682257-2f9c37a3a5f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Managing Client Expectations": "https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Handling Business Card Exchange": "https://images.unsplash.com/photo-1572021335469-31706a17aaef?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Workplace Social Scenarios (32-50)
  "Mentoring a Struggling Team Member": "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Remote Work Communication": "https://images.unsplash.com/photo-1628348068343-c6a848d2b6dd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Addressing a Mistake Publicly": "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Managing Interview Anxiety": "https://images.unsplash.com/photo-1569078449082-7ad92771a4a1?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Social Activities Scenarios
  "Party Social Skills": "https://images.unsplash.com/photo-1529634456207-3d7521512ec9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "First Meeting Small Talk": "https://images.unsplash.com/photo-1543269865-cbf427effbad?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Online Social Events": "https://images.unsplash.com/photo-1609921212029-bb5a28e60960?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Community Engagement": "https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Interpersonal Relationships Scenarios
  "Communication in Romantic Relationships": "https://images.unsplash.com/photo-1516726817505-f5ed825624d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Managing Family Relationships": "https://images.unsplash.com/photo-1511895426328-dc8714191300?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Resolving Conflicts Among Friends": "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Difficult Conversations and Everyday Etiquette
  "Declining Requests": "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Expressing Disagreement": "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  "Apologizing and Reconciliation": "https://images.unsplash.com/photo-1571945153237-4929e783af4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80",
  
  // Default image for scenarios without specific mappings
  "default": "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
};

function ScenarioList() {
  const [scenarios, setScenarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [hasSubscription, setHasSubscription] = useState(false);
  const [showAllScenarios, setShowAllScenarios] = useState(true);
  
  const { currentUser, userData, isAdmin } = useAuth();
  const navigate = useNavigate();
  
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

  // 检查用户订阅状态
  useEffect(() => {
    // 使用userData中的valid_subscription字段判断订阅状态
    if (userData && userData.valid_subscription) {
      setHasSubscription(true);
    } else {
      setHasSubscription(false);
    }
  }, [userData]);

  // 从MongoDB获取场景列表
  useEffect(() => {
    let isMounted = true; // 跟踪组件是否挂载
    
    async function fetchScenarios() {
      try {
        if (!isMounted) return; // 如果组件已卸载，退出函数
        setLoading(true);
        setError('');
        
        // 添加调试日志
        console.log('开始获取场景数据');
        
        let scenarioList = [];
        let token = null;
        
        // 如果用户已登录，使用token获取场景
        if (currentUser) {
          token = localStorage.getItem('token');
          console.log('用户已登录，使用token获取场景');
        }
        
        try {
          // 准备请求配置
          const requestOptions = {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          };
          
          // 如果有token添加到请求头
          if (token) {
            requestOptions.headers['Authorization'] = `Bearer ${token}`;
          }
          
          console.log(`尝试从API获取场景: ${API_URL}/api/scenarios`);
          
          // 尝试从API获取场景
          const response = await fetch(`${API_URL}/api/scenarios`, requestOptions);
          
          if (!response.ok) {
            const statusText = response.statusText || '未知错误';
            console.error(`API请求失败，状态: ${response.status} ${statusText}`);
            throw new Error(`API request failed with status: ${response.status} ${statusText}`);
          }
          
          const data = await response.json();
          
          // 确保API返回了场景数组
          if (!data.scenarios || !Array.isArray(data.scenarios)) {
            console.error("API返回数据格式错误:", data);
            throw new Error("Data format error, missing scenarios array");
          }
          
          console.log(`成功从API加载 ${data.scenarios.length} 个场景`);
          
          // 处理场景数据
          scenarioList = data.scenarios.map(scenario => {
            // 查找基于场景标题的适当图片
            const image = SCENARIO_IMAGES[scenario.title_en] || SCENARIO_IMAGES.default;
            
            return {
              id: scenario._id,
              title: scenario.title_en,
              description: scenario.scenario_en,
              is_free: !scenario.is_premium,
              image: image // 添加图片URL
            };
          });
        } catch (apiError) {
          console.error("API请求失败，回退到本地数据:", apiError);
          
          // 如果API请求失败，尝试多个可能的路径加载本地数据
          let fallbackData = null;
          let fallbackSuccess = false;
          
          const fallbackPaths = [
            '/combinedScenariosData.json',
            './combinedScenariosData.json',
            '/public/combinedScenariosData.json',
            '../public/combinedScenariosData.json',
            'combinedScenariosData.json'
          ];
          
          for (const path of fallbackPaths) {
            try {
              console.log(`尝试从路径加载数据: ${path}`);
              const response = await fetch(path);
              if (response.ok) {
                fallbackData = await response.json();
                console.log(`成功从${path}加载数据`);
                fallbackSuccess = true;
                break;
              }
            } catch (err) {
              console.error(`从${path}加载数据失败:`, err);
            }
          }
          
          if (!fallbackSuccess) {
            throw new Error("无法从任何路径加载场景数据");
          }
          
          if (!fallbackData.scenarios || !Array.isArray(fallbackData.scenarios)) {
            throw new Error("回退数据格式错误，缺少scenarios数组");
          }
          
          console.log(`使用回退数据，共${fallbackData.scenarios.length}个场景`);
          
          // 处理本地场景数据
          scenarioList = fallbackData.scenarios.map(scenario => {
            const image = SCENARIO_IMAGES[scenario.title_en] || SCENARIO_IMAGES.default;
            
            return {
              id: scenario.id,
              title: scenario.title_en,
              description: scenario.scenario_en,
              is_free: !scenario.is_premium,
              image: image
            };
          });
        }
        
        // 添加调试
        console.log(`处理完成，共有 ${scenarioList.length} 个场景`);
        
        // 确保scenarioList是有效的数组
        if (!Array.isArray(scenarioList)) {
          console.error('场景列表不是数组:', scenarioList);
          throw new Error('Invalid scenario list format');
        }
        
        // 使用hasSubscription和isAdmin判断权限
        if (!hasSubscription && !isAdmin) {
          scenarioList = scenarioList.filter(scenario => scenario.is_free);
          console.log(`过滤后的免费场景数: ${scenarioList.length}`);
        }
        
        // 按免费和付费内容排序
        scenarioList.sort((a, b) => {
          // 首先按免费/付费划分
          if (a.is_free !== b.is_free) return a.is_free ? -1 : 1;
          // 其次按标题字母顺序
          return a.title.localeCompare(b.title);
        });
        
        // 确保组件仍然挂载
        if (isMounted) {
          setScenarios(scenarioList);
          console.log('场景数据已更新到状态');
        }
      } catch (err) {
        console.error("加载场景列表时出错:", err);
        // 确保组件仍然挂载
        if (isMounted) {
          setError('Failed to load scenarios, please refresh the page and try again.');
        }
      } finally {
        // 确保组件仍然挂载
        if (isMounted) {
          setLoading(false);
        }
      }
    }
    
    fetchScenarios();
    
    // 清理函数
    return () => {
      isMounted = false;
    };
  }, [API_URL, currentUser, hasSubscription, isAdmin]);

  // Start complete test
  const startFullTest = () => {
    navigate('/full-test');
  };

  // View all scenarios
  const viewAllScenarios = () => {
    setShowAllScenarios(true);
    // Smooth scroll to scenarios section
    document.getElementById('scenarios-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Loading indicator component
  const LoadingIndicator = () => (
    <div className="loading-indicator">
      <div className="spinner"></div>
      <p>Loading scenario list...</p>
    </div>
  );

  // Error message component
  const ErrorMessage = ({ message }) => (
    <div className="error-container">
      <h3>Error</h3>
      <p>{message}</p>
      <button className="primary-button" onClick={() => window.location.reload()}>Refresh page</button>
    </div>
  );

  // Empty state component
  const EmptyState = () => (
    <div className="empty-state">
      <h3>No scenarios available</h3>
      <p>There are currently no test scenarios available. Please check back later.</p>
      {!hasSubscription && currentUser && (
        <div className="upgrade-prompt">
          <p>所有场景都已免费开放</p>
          <button className="primary-button" onClick={() => window.location.href = '/advanced-scenarios'}>查看更多场景</button>
        </div>
      )}
    </div>
  );

  if (loading) {
    return <LoadingIndicator />;
  }

  if (error) {
    return <ErrorMessage message={error} />;
  }

  if (scenarios.length === 0) {
    return <EmptyState />;
  }

  return (
    <div className="scenarios-container">
      {/* Hero Section */}
      <div className="hero-section">
        <h1 className="hero-title">From Awkward to Awesome</h1>
        <p className="hero-subtitle">Practical social intelligence training for real-world situations</p>
      </div>

      {/* CTA Action Buttons */}
      <div className="action-buttons">
        {/* Start Test Button Row */}
        <div className="action-button-row">
          <div className="action-button-content">
            <h2>Test Your EQ</h2>
            <p>Take our comprehensive social intelligence assessment to evaluate your emotional intelligence in real-world scenarios.</p>
            <button className="primary-button cta-button" onClick={startFullTest}>Start Test</button>
          </div>
          <div className="action-button-image">
            <img src="https://images.unsplash.com/photo-1573497620053-ea5300f94f21?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3000&q=80" alt="Person taking test" />
          </div>
        </div>

        {/* View Scenarios Button Row */}
        <div className="action-button-row reverse">
          <div className="action-button-content">
            <h2>Practice Scenarios</h2>
            <p>Explore our library of social scenarios with expert advice to improve your interaction skills in various situations.</p>
            <button className="secondary-button cta-button" onClick={viewAllScenarios}>View Scenarios</button>
          </div>
          <div className="action-button-image">
            <img src="https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=3000&q=80" alt="People in a meeting" />
          </div>
        </div>
      </div>

      {/* Scenarios List Section */}
      <div id="scenarios-section" className="scenarios-section">
        <h2 className="section-title">Social Scenarios</h2>
        {scenarios.length === 0 ? (
          <EmptyState />
        ) : (
          <>
            <div className="scenarios-list">
              {scenarios.map(scenario => (
                <ScenarioItem 
                  key={scenario.id}
                  id={scenario.id}
                  title={scenario.title || scenario.title_en}
                  description={scenario.description || scenario.scenario_en}
                  isPremium={!scenario.is_free}
                  image={scenario.image}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default ScenarioList; 